module.exports = __webpack_public_path__ + "img/ios-log-in.eed1898b.svg";